import list from './niCountryList.json';

export const niCountryList = () => {
    return list.map(item => item.Name)
}
export const getNiCountryId = (name) => {
    return list.find(item => item.Name === name)?.Id || "";
}